import {fetchApi} from "@/lib/fetch/fetchApi";
import {configurationType, userType} from "@/lib/definitions/definitions";

export function getJsonStorage(configuration: configurationType, securityToken: string|null) {

    return fetchApi({
        route: 'tenant/json-storage',
        type: "GET",
        configuration: configuration,
        securityToken: securityToken
    })

}